import { useAuthUser } from "@/App";

/**
 * v7.04 → v7.10 — VIDEO GATE, now plan-aware. While video is still being
 * built it stays admin-only ("Coming Soon" everywhere). Once video GAs the
 * server flips VIDEO_GA_ENABLED=1 and /api/auth/me starts reporting
 * entitlements.videoAccess=true for Pro/Agency plans — no client deploy
 * needed. Starter users then see the UPGRADE copy instead of Coming Soon
 * (entitlements.videoGa distinguishes the two states).
 *
 * This hook is the ONLY client-side definition of the gate — keep every
 * surface (composer Video tab, Discover/Assets Clone buttons, chat) reading
 * it. The real enforcement is server-side (the /api/video-clone router 403s
 * every mutating route, and the chat agent short-circuits): this is the
 * courtesy layer that keeps users from reaching for something that would
 * only fail.
 */
export function useVideoEnabled(): boolean {
  const user = useAuthUser();
  return Boolean(user?.isAdmin || user?.entitlements?.videoAccess);
}

/** The right refusal copy for the current era: pre-GA everyone locked sees
 *  "coming soon"; post-GA a locked user is on a plan without video, so the
 *  honest line is the upgrade one. */
export function useVideoGateCopy(): { long: string; short: string } {
  const user = useAuthUser();
  if (user?.entitlements?.videoGa) {
    return { long: VIDEO_UPGRADE_REQUIRED, short: VIDEO_UPGRADE_SHORT };
  }
  return { long: VIDEO_COMING_SOON, short: VIDEO_COMING_SOON_SHORT };
}

export const VIDEO_COMING_SOON = "Admoji Video Ads are coming soon";
export const VIDEO_COMING_SOON_SHORT = "Coming Soon";
export const VIDEO_UPGRADE_REQUIRED = "Video Ads are available on Pro and Agency plans — upgrade to unlock them";
export const VIDEO_UPGRADE_SHORT = "Upgrade for Video";
